import { Tag } from 'antd';
import { CrownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { TENANT_ROLE_COLORS, isTenantRole } from '@/constants/tenantRoles';

export interface TenantRoleTagProps {
  /** Tenant role as returned by the API (OWNER, EMPLOYEE or CUSTOMER) */
  role: string;
  /** Shows "Tenant name · Role" instead of the role alone (e.g. in user lists) */
  tenantName?: string;
  /** Replaces the tag text entirely */
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

/**
 * Read-only tenant role tag with the same colours and owner crown everywhere in the app.
 * Unknown roles render as a neutral tag with the raw value.
 */
export function TenantRoleTag({ role, tenantName, children, style }: TenantRoleTagProps) {
  const { t } = useTranslation('common');
  const roleLabel = isTenantRole(role) ? t(`tenantRoles.${role}.label`) : role;
  const text = children ?? (tenantName ? `${tenantName} · ${roleLabel}` : roleLabel);

  if (!isTenantRole(role)) {
    return <Tag style={style}>{text}</Tag>;
  }

  return (
    <Tag color={TENANT_ROLE_COLORS[role]} icon={role === 'OWNER' ? <CrownOutlined /> : undefined} style={style}>
      {text}
    </Tag>
  );
}
